import { makeAutoObservable } from "mobx";

class GlobalStore {
  constructor() {
    makeAutoObservable(this);
  }
  // 当前地图类型  
  wechartList = [];
  moduleData = [];
  userInfo = {};
  setModuleData = (obj) => {
    this.moduleData = obj;
  }; 
  setUserInfo = (obj) => {
    this.userInfo = obj;
  }; 
  setWechartList = (obj) => {
    this.wechartList = obj;
  };  
}
const globalStore = new GlobalStore()
export default globalStore;
